module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/rule-cc07f46d7e5e959ac617add0d4fc51d3.svg";